import React, { useEffect, useMemo } from 'react';
import type { SnippetRendererProps } from '@atlaskit/link-provider';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';

import { expVal } from '@atlassian/jira-feature-experiments';
import { isFedRamp } from '@atlassian/atl-context';
import { aiSnippetEntryPoint } from '@atlassian/ai-snippet/entrypoint';

export const JiraSnippetRenderer = (props: SnippetRendererProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(aiSnippetEntryPoint, {});

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	const runtimeProps = useMemo(
		() => ({
			contentId: props.contentId,
			contentType: props.contentType,
			cloudId: props.cloudId,
			fallbackText: props.fallbackText,
			fallbackComponent: props.fallbackComponent,
			isHidden: props.isHidden,
			maxLines: props.maxLines,
			showFooter: props.showFooter,
		}),
		[
			props.contentId,
			props.contentType,
			props.cloudId,
			props.fallbackText,
			props.fallbackComponent,
			props.isHidden,
			props.maxLines,
			props.showFooter,
		],
	);

	if (isFedRamp() || !expVal('jira-cc-ai-snippet-experiment', 'should_render_ai_snippet', false)) {
		return props.fallbackComponent;
	}

	return (
		<JiraEntryPointContainer
			id="jira.smartcard.ai-snippet"
			packageName="jiraSmartcardAiSnippet"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={runtimeProps}
			fallback={props.fallbackComponent}
		/>
	);
};
